import React from "react"
import clsx from "clsx"

import { Asset } from "components"

function Gallery({ galleryVideo, images }) {
  return (
    <section data-slice="Gallery" className="py-10 wrapper lg:py-0">
      <div className="items-center default-grid">
        {images && images[0] && (
          <div className="hidden col-span-2 lg:block">
            <div
              style={{
                width: "200%",
                marginLeft: "-100%",
                paddingTop: "166.667%",
              }}
            >
              <div className="aspect-w-1 aspect-h-1">
                <Asset
                  asset={{ ...images[0], gatsbyImageData: images[0].small }}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {(galleryVideo || (images && images[1])) && (
          <div className="self-center col-span-full lg:col-span-8">
            <div className="w-full">
              <div className={clsx("aspect-w-5 aspect-h-3")}>
                {!galleryVideo && (
                  <Asset
                    asset={{ ...images[1], gatsbyImageData: images[1].large }}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
                {galleryVideo && (
                  <iframe
                    src={galleryVideo}
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                    style={{ padding: "1px" }}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {images && images[2] && (
          <div className="hidden col-span-2 lg:block">
            <div style={{ width: "200%", paddingBottom: "166.667%" }}>
              <div className="aspect-w-1 aspect-h-1">
                <Asset
                  asset={{ ...images[2], gatsbyImageData: images[2].small }}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default Gallery
